import React from 'react';
import {Button, Flex} from '@priority-software/priority-style-react';
import cx from 'classnames';
import styles from '.././styles.module.scss';

interface ContentBtnType {
    isWelcomePage: boolean;
    backwardsBtnText: string;
    forwardBtnText: string;
    handleBackBtn: () => void;
    handleConfirmBtn: () => void;
}
export const ContentBtn = (props: ContentBtnType) => {
    const {isWelcomePage, backwardsBtnText, forwardBtnText, handleBackBtn, handleConfirmBtn} =
        props;

    return (
        <Flex
            componentClasses={styles.buttonFlex}
            justifyContent={isWelcomePage ? 'flex-end' : 'space-between'}
            alignItems="center"
        >
            <Button
                componentClasses={cx(styles.dialogContentBtn, {
                    [styles.btnMargin]: !isWelcomePage
                })}
                onClick={handleBackBtn}
                skin="secondary"
                width="regularFixed"
                size="medium"
            >
                {backwardsBtnText}
            </Button>
            <Button
                componentClasses={cx(styles.dialogContentBtn, {[styles.btnMargin]: !isWelcomePage})}
                onClick={handleConfirmBtn}
                autoFocus={true}
                skin="primary"
                width="regularFixed"
                size="medium"
            >
                {forwardBtnText}
            </Button>
        </Flex>
    );
};
